var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4866 1.30902V3.0367H0.513393V1.30902H3.48661L4.37054 0.465271H8.62946L9.51339 1.30902H12.4866ZM1.35714 14.1662V3.88045H11.6429V14.1662C11.6429 14.6215 11.4687 15.0233 11.1205 15.3715C10.7723 15.7197 10.3705 15.8938 9.91518 15.8938H3.08482C2.62946 15.8938 2.22768 15.7197 1.87946 15.3715C1.53125 15.0233 1.35714 14.6215 1.35714 14.1662Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.98b463339bf3fdbe55788e054905b776.svg";
export { ForwardRef as ReactComponent };